/**
 * Adds Google Analytics scripts
 */

const addGtagScript = () => {
  // const script = document.querySelector('[data-item="analytics-script"]')

  // if (script) {
  //   script.src = script.getAttribute('data-src')
  // }
  //dd
  // window.dataLayer = window.dataLayer || []

  // function gtag() {
  //   dataLayer.push(arguments)
  // }

  // gtag('consent', 'default', {
  //   ad_storage: 'denied',
  //   analytics_storage: 'denied',
  //   functionality_storage: 'denied',
  //   personalization_storage: 'denied',
  //   ad_user_data: 'denied',
  //   ad_personalization: 'denied',
  //   security_storage: 'granted',
  //   wait_for_update: 5000,
  // })

  //   (function (w, d, s, l, i) {
  //     w[l] = w[l] || []; w[l].push({
  //       'gtm.start':

  //         new Date().getTime(), event: 'gtm.js'
  //     }); var f = d.getElementsByTagName(s)[0],

  //       j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =

  //         'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);

  //   })(window, document, 'script', 'dataLayer', 'GTM-5BGZX9CR');




  window.dataLayer = window.dataLayer || [];

  function gtag() {
    dataLayer.push(arguments);
  }

  gtag('consent', 'default', {
    ad_storage: "denied",
    analytics_storage: "denied",
    functionality_storage: "denied",
    personalization_storage: "denied",
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    security_storage: "granted",
    wait_for_update: 5000
  });

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src =
      'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-5BGZX9CR');
}

addGtagScript()

const updateAnalytics = () => {
  console.log('updateAnalytics')
  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }

  gtag('consent', 'update', {
    analytics_storage: 'granted',
  })
}

const updateAds = () => {
  console.log('updateAds')
  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }
  gtag('consent', 'update', {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    personalization_storage: 'granted',
  })
}

const updatePreferences = () => {
  console.log('updatePreferences')
  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }
  gtag('consent', 'update', {
    functionality_storage: 'granted',
  })
}

/**
 * Starts Google Analytics on bw-cookies-action event if Analyticks cookies are accepted
 */
window.addEventListener('bw-cookies-action', () => {
  if (window.CookiesController) {
    if (
      window.CookiesController.isCookieAccepted('bw-cookie-google-analytics')
    ) {
      updateAnalytics()
    }
    if (
      window.CookiesController.isCookieAccepted('bw-cookie-google-marketing')
    ) {
      updateAds()
    }
    if (
      window.CookiesController.isCookieAccepted('bw-cookie-google-preferences')
    ) {
      updatePreferences()
    }
    window.removeEventListener('bw-cookies-action', this)
  }
})
